import * as z from "zod";
import { ElementSchema } from "./element-schema";
import { ImageSchema } from "./image-schema";

export const SlideType = z.enum(["title", "content", "image", "quote"]);

export const CommonSlideSchema = z.object({
  elements: z.array(ElementSchema),
  backgroundImage: ImageSchema.optional(),
}); 